<template>
  <div class="enroll-page">
    <!-- 学校端：提交报名 + 查看进度 -->
    <div v-if="$store.state.role === 'school-role'">
      <div class="section-card">
        <div class="section-title">大赛报名</div>

        <div class="enroll-form-grid">
          <div class="form-row">
            <div class="label"><span class="required">*</span>组别</div>
            <div class="form-row-content">
              <a-radio-group v-model="form.levelType">
                <a-radio value="1">中职组</a-radio>
                <a-radio value="2">高职组</a-radio>
              </a-radio-group>
            </div>
          </div>

          <!-- <div class="form-row">
            <div class="label"><span class="required">*</span>团队类型</div>
            <div class="form-row-content">
              <a-radio-group v-model="form.teamType">
                <a-radio value="teacher">教师团队</a-radio>
                <a-radio value="student">学生团队</a-radio>
              </a-radio-group>
            </div>
          </div> -->

          <div class="form-row">
            <div class="label"><span class="required">*</span>作品名称</div>
            <div class="form-row-content">
              <a-input
                v-model="form.zpname"
                placeholder="请输入作品名称"
                :maxLength="60"
                allow-clear
              />
            </div>
          </div>

          <div class="form-row">
            <div class="label"><span class="required">*</span>作品负责人</div>
            <div class="form-row-content">
              <a-input
                v-model="form.principal"
                placeholder="请输入作品负责人"
                :maxLength="30"
                allow-clear
              />
            </div>
          </div>

          <div class="form-row form-row--full form-row-top">
            <div class="label"><span class="required">*</span>团队成员</div>
            <div class="form-row-content">
              <team-member-tags v-model="form.teams" />
            </div>
          </div>

          <div class="form-row form-row--full">
            <div class="label"><span class="required">*</span>学校意见</div>
            <div class="form-row-content">
              <a-textarea
                v-model="form.suggestion"
                :auto-size="{ minRows: 2, maxRows: 4 }"
                placeholder="请输入学校意见"
              />
            </div>
          </div>

          <div class="form-row form-row--full">
            <div class="label"><span class="required">*</span>报名表</div>
            <div class="form-row-content form-row-content--inline">
              <a-upload
                :before-upload="beforeUpload"
                :show-upload-list="false"
                accept=".pdf,.doc,.docx,.xls,.xlsx"
              >
                <a-button :loading="uploading">上传报名表</a-button>
              </a-upload>
              <div class="file-tip" v-if="formFileName">
                已上传：{{ formFileName }}
              </div>
            </div>
          </div>
        </div>

        <div class="actions">
          <a-button type="primary" @click="submitEnroll" :loading="submitting"
            >提交报名</a-button
          >
        </div>
      </div>

      <div ref="myRecordSection" class="record-section">
        <div class="section-title">我的报名记录</div>
        <div class="list-filter-panel">
          <div class="list-filter-row filter-dimension-grid filter-dimension-grid--my">
            <div class="filter-dimension-block filter-dimension-block--primary">
              <div class="filter-dimension-title">大赛分组</div>
              <div class="filter-chip-list filter-chip-list--my">
                <span
                  class="filter-chip filter-chip--my"
                  :class="{ active: !myQuery.levelType }"
                  @click="setMyLevelFilter()"
                >全部</span>
                <span
                  class="filter-chip filter-chip--my"
                  :class="{ active: myQuery.levelType === '1' }"
                  @click="setMyLevelFilter('1')"
                >中职组</span>
                <span
                  class="filter-chip filter-chip--my"
                  :class="{ active: myQuery.levelType === '2' }"
                  @click="setMyLevelFilter('2')"
                >高职组</span>
              </div>
            </div>
            <!-- <div class="filter-dimension-block filter-dimension-block--primary">
              <div class="filter-dimension-title">团队类型</div>
              <div class="filter-chip-list filter-chip-list--my">
                <span
                  class="filter-chip filter-chip--my"
                  :class="{ active: !myQuery.teamType }"
                  @click="setMyTeamFilter()"
                >全部</span>
                <span
                  class="filter-chip filter-chip--my"
                  :class="{ active: myQuery.teamType === 'teacher' }"
                  @click="setMyTeamFilter('teacher')"
                >教师团队</span>
                <span
                  class="filter-chip filter-chip--my"
                  :class="{ active: myQuery.teamType === 'student' }"
                  @click="setMyTeamFilter('student')"
                >学生团队</span>
              </div>
            </div> -->
          </div>
          <div class="list-filter-row list-filter-search-row">
            <a-input-search
              v-model="myQuery.keyword"
              placeholder="搜索作品名称、负责人、团队成员"
              allow-clear
              class="list-filter-search"
              @search="loadMyList"
            />
          </div>
          <div class="list-filter-footer">
            <a-button size="default" @click="resetMyQuery">重置筛选</a-button>
            <a-button type="primary" size="default"  @click="loadMyList">查询</a-button>
            <span class="list-filter-count">
              共 <b>{{ myList.length }}</b> 条记录
            </span>
          </div>
        </div>
        <a-table
          class="enroll-table"
          :columns="schoolColumns"
          :data-source="myList"
          :loading="loadingMyList"
          rowKey="id"
          :pagination="false"
          :bordered="true"
          :scroll="{ x: 1200 }"
          :locale="{ emptyText: '暂无数据' }"
        >
          <template slot="teams" slot-scope="text, record">
            <team-members-display :value="record._rawTeams || text" />
          </template>
          <template slot="suggestion" slot-scope="text">
            <span class="cell-ellipsis" :title="text && text !== '-' ? text : ''">{{ text && text !== '-' ? text : "-" }}</span>
          </template>
          <template slot="formFilePath" slot-scope="text, record">
            <a
              v-if="record._rawFormPath"
              @click="openPreview(record._rawFormPath)"
            >
              查看报名表
            </a>
            <span v-else>-</span>
          </template>
          <template slot="enrollStatus" slot-scope="text">
            <span :class="getStatusClass(text)">{{ text }}</span>
          </template>
          <template slot="action" slot-scope="record">
          <div class="action-group">
            <a
              v-if="record._rawEnrollStatus === 2"
              class="action-resubmit"
              @click="openResubmit(record)"
              >编辑</a
            >
            <a-popconfirm
              v-if="record._rawEnrollStatus !== 1"
              title="确认删除该报名记录？"
              ok-text="确认"
              cancel-text="取消"
              @confirm="handleDelete(record)"
            >
              <a class="action-delete">删除</a>
            </a-popconfirm>
            <span v-else>-</span>
          </div>
          </template>
        </a-table>
      </div>

      <a-modal
        v-model="resubmit.visible"
        title="驳回记录编辑"
        :width="720"
        cancel-text="取消"
      >
        <template slot="footer">
          <a-button @click="resubmit.visible = false">取消</a-button>
          <a-button type="default" :loading="resubmit.saving" @click="doResubmitSave">保存修改</a-button>
          <a-button type="primary" :loading="resubmit.submitting" @click="doResubmitSubmit">重新提交</a-button>
        </template>
        <div class="modal-form">
          <div class="enroll-form-grid">
            <div class="form-row">
              <div class="label"><span class="required">*</span>组别</div>
              <div class="form-row-content">
                <a-radio-group v-model="resubmit.form.levelType">
                  <a-radio value="1">中职组</a-radio>
                  <a-radio value="2">高职组</a-radio>
                </a-radio-group>
              </div>
            </div>

            <!-- <div class="form-row">
              <div class="label"><span class="required">*</span>团队类型</div>
              <div class="form-row-content">
                <a-radio-group v-model="resubmit.form.teamType">
                  <a-radio value="teacher">教师团队</a-radio>
                  <a-radio value="student">学生团队</a-radio>
                </a-radio-group>
              </div>
            </div> -->

            <div class="form-row">
              <div class="label"><span class="required">*</span>作品名称</div>
              <div class="form-row-content">
                <a-input
                  v-model="resubmit.form.zpname"
                  placeholder="请输入作品名称"
                  :maxLength="60"
                  allow-clear
                />
              </div>
            </div>

            <div class="form-row">
              <div class="label"><span class="required">*</span>作品负责人</div>
              <div class="form-row-content">
                <a-input
                  v-model="resubmit.form.principal"
                  placeholder="请输入作品负责人"
                  :maxLength="30"
                  allow-clear
                />
              </div>
            </div>

            <div class="form-row form-row--full form-row-top">
              <div class="label"><span class="required">*</span>团队成员</div>
              <div class="form-row-content">
                <team-member-tags v-model="resubmit.form.teams" />
              </div>
            </div>

            <div class="form-row form-row--full">
              <div class="label"><span class="required">*</span>学校意见</div>
              <div class="form-row-content">
                <a-textarea
                  v-model="resubmit.form.suggestion"
                  :auto-size="{ minRows: 2, maxRows: 4 }"
                  placeholder="请输入学校意见"
                />
              </div>
            </div>

            <div class="form-row form-row--full">
              <div class="label"><span class="required">*</span>报名表</div>
              <div class="form-row-content form-row-content--inline">
                <a-upload
                  :before-upload="beforeUploadResubmit"
                  :show-upload-list="false"
                  accept=".pdf,.doc,.docx,.xls,.xlsx"
                >
                  <a-button :loading="resubmit.uploading">重新上传报名表</a-button>
                </a-upload>
                <div class="file-tip" v-if="resubmit.formFileName">
                  当前：{{ resubmit.formFileName }}
                </div>
              </div>
            </div>
          </div>

          <div v-if="resubmit.rejectReason" class="reject-reason">
            <div class="reject-title">驳回原因</div>
            <div class="reject-text">{{ resubmit.rejectReason }}</div>
          </div>
        </div>
      </a-modal>
    </div>

    <!-- 教育局端：报名审核 -->
    <div v-else-if="$store.state.role === 'education-role'">
      <a-spin :spinning="exportingForms || exportingExcel" :tip="exportSpinTip">
      <div class="section-title">报名审核</div>

      <div class="list-filter-panel">
        <div class="list-filter-row filter-dimension-grid filter-dimension-grid--cols-3">
          <div class="filter-dimension-block filter-dimension-block--primary">
            <div class="filter-dimension-title">大赛分组</div>
            <div class="filter-chip-list filter-chip-list--lg">
              <span
                class="filter-chip filter-chip--lg"
                :class="{ active: !query.levelType }"
                @click="setJyjLevelFilter()"
              >全部</span>
              <span
                class="filter-chip filter-chip--lg"
                :class="{ active: query.levelType === '1' }"
                @click="setJyjLevelFilter('1')"
              >中职组</span>
              <span
                class="filter-chip filter-chip--lg"
                :class="{ active: query.levelType === '2' }"
                @click="setJyjLevelFilter('2')"
              >高职组</span>
            </div>
          </div>
          <!-- <div class="filter-dimension-block filter-dimension-block--primary">
            <div class="filter-dimension-title">团队类型</div>
            <div class="filter-chip-list filter-chip-list--lg">
              <span
                class="filter-chip filter-chip--lg"
                :class="{ active: !query.teamType }"
                @click="setJyjTeamFilter()"
              >全部</span>
              <span
                class="filter-chip filter-chip--lg"
                :class="{ active: query.teamType === 'teacher' }"
                @click="setJyjTeamFilter('teacher')"
              >教师团队</span>
              <span
                class="filter-chip filter-chip--lg"
                :class="{ active: query.teamType === 'student' }"
                @click="setJyjTeamFilter('student')"
              >学生团队</span>
            </div>
          </div> -->
          <div class="filter-dimension-block filter-dimension-block--primary">
            <div class="filter-dimension-title">审核状态</div>
            <div class="filter-chip-list filter-chip-list--lg">
              <span
                class="filter-chip filter-chip--lg"
                :class="{ active: query.enrollStatus === undefined || query.enrollStatus === null || query.enrollStatus === '' }"
                @click="setJyjStatusFilter()"
              >全部</span>
              <span
                class="filter-chip filter-chip--lg"
                :class="{ active: query.enrollStatus === 0 }"
                @click="setJyjStatusFilter(0)"
              >待审</span>
              <span
                class="filter-chip filter-chip--lg status-pass-chip"
                :class="{ active: query.enrollStatus === 1 }"
                @click="setJyjStatusFilter(1)"
              >通过</span>
              <span
                class="filter-chip filter-chip--lg status-reject-chip"
                :class="{ active: query.enrollStatus === 2 }"
                @click="setJyjStatusFilter(2)"
              >驳回</span>
            </div>
          </div>
        </div>
        <div class="list-filter-row list-filter-search-row">
          <a-input-search
            v-model="query.schoolName"
            placeholder="搜索学校名称"
            allow-clear
            class="list-filter-search"
            @search="loadJyjList(1)"
          />
          <a-input-search
            v-model="query.keyword"
            placeholder="搜索作品名称、负责人、团队成员"
            allow-clear
            class="list-filter-search"
            @search="loadJyjList(1)"
          />
        </div>
        <div class="list-filter-footer list-filter-footer--jyj">
          <a-button  @click="resetJyjQuery">重置筛选</a-button>
          <a-button type="primary"  @click="loadJyjList(1)">查询</a-button>
          <span class="list-filter-footer-split"></span>
          <span class="jyj-batch-tip">
            已选 <b>{{ jyjSelectedRowKeys.length }}</b> 条
          </span>
          <a-button
            
            class="jyj-batch-btn jyj-batch-btn--pass"
            :class="{ 'is-ready': jyjSelectedApprovableCount }"
            :disabled="!jyjSelectedApprovableCount"
            @click="openBatchAudit(1)"
          >批量通过</a-button>
          <a-button
           
            class="jyj-batch-btn jyj-batch-btn--reject"
            :class="{ 'is-ready': jyjSelectedPendingCount }"
            :disabled="!jyjSelectedPendingCount"
            @click="openBatchAudit(2)"
          >批量驳回</a-button>
          <div class="jyj-export-group">
            <a-tooltip title="按当前筛选导出 Excel 列表">
              <a-button
               
                icon="file-excel"
                class="jyj-export-btn jyj-export-btn--excel"
                :loading="exportingExcel"
                @click="exportJyjExcel"
              >导出列表</a-button>
            </a-tooltip>
            <a-tooltip title="打包导出已通过的报名表">
              <a-button
               
                icon="file-zip"
                class="jyj-export-btn jyj-export-btn--zip"
                :loading="exportingForms"
                @click="exportApprovedForms"
              >导出报名表</a-button>
            </a-tooltip>
          </div>
          <span class="list-filter-count">
            共 <b>{{ pagination.total }}</b> 条记录
          </span>
        </div>
      </div>

      <a-table
        class="enroll-table"
        :columns="jyjColumns"
        :data-source="jyjList"
        :loading="loadingJyjList"
        rowKey="id"
        :rowSelection="jyjRowSelection"
        :pagination="pagination"
        :bordered="true"
        :scroll="{ x: jyjTableScrollX }"
        :locale="{ emptyText: '暂无数据' }"
        @change="onTableChange"
      >
        <template slot="teams" slot-scope="text, record">
          <team-members-display :value="record._rawTeams || text" />
        </template>
        <template slot="suggestion" slot-scope="text">
          <span class="cell-ellipsis" :title="text && text !== '-' ? text : ''">{{ text && text !== '-' ? text : "-" }}</span>
        </template>
        <template slot="formFilePath" slot-scope="text, record">
          <a
            v-if="record._rawFormPath"
            @click="openPreview(record._rawFormPath)"
          >
            查看报名表
          </a>
          <span v-else>-</span>
        </template>
        <template slot="enrollStatus" slot-scope="text">
          <span :class="getStatusClass(text)">{{ text }}</span>
        </template>
        <template slot="rejectReason" slot-scope="text">
          <span class="cell-ellipsis" :title="text && text !== '-' ? text : ''">{{ text && text !== '-' ? text : "-" }}</span>
        </template>
        <template slot="action" slot-scope="record">
          <div class="action-group">
            <a
              v-if="isApprovableStatus(record._rawEnrollStatus)"
              class="action-pass"
              @click="openAudit(record, 1)"
              >通过</a
            >
            <a
              v-if="isRejectableStatus(record._rawEnrollStatus)"
              class="action-reject"
              @click="openAudit(record, 2)"
              >驳回</a
            >
            <a-popconfirm
              title="确认删除该报名记录？"
              ok-text="确认"
              cancel-text="取消"
              @confirm="handleDelete(record)"
            >
              <a class="action-delete">删除</a>
            </a-popconfirm>
          </div>
        </template>
      </a-table>

      <a-modal
        v-model="audit.visible"
        :title="auditModalTitle"
        @ok="doAudit"
        :confirm-loading="audit.submitting"
        ok-text="确认"
        cancel-text="取消"
      >
        <div v-if="audit.status === 2">
          <div style="margin-bottom: 8px">
            驳回原因（{{ audit.ids.length }} 条）
          </div>
          <a-textarea v-model="audit.rejectReason" :maxLength="200" placeholder="请填写驳回原因" />
        </div>
        <div v-else>
          确认通过{{ audit.ids.length > 1 ? `选中的 ${audit.ids.length} 条` : "该" }}报名记录？
        </div>
      </a-modal>
      </a-spin>
    </div>

    <div v-else class="empty-tip">当前角色无此功能。</div>

    <preview-img ref="previewImg"></preview-img>
  </div>
</template>

<script>
import {
  fileUp,
  lxEnrollMyList,
  lxEnrollSaveOrUpdate,
  lxEnrollJyjList,
  lxEnrollAudit,
  lxEnrollDelete,
  lxEnrollUpdateRejected,
  lxEnrollExportApprovedZip,
  lxEnrollExportExcel,
} from "@/api/index";
import previewImg from "@/components/previewImg.vue";
import teamMemberTags from "@/components/common/teamMemberTags.vue";
import teamMembersDisplay from "@/components/common/teamMembersDisplay.vue";

export default {
  name: "competitionEnroll",
  components: {
    previewImg,
    teamMemberTags,
    teamMembersDisplay,
  },
  data() {
    return {
      uploading: false,
      submitting: false,
      formFileName: "",
      form: {
        // 当前实现仅用于“教学能力大赛”赛道；如果后续要扩展多赛道，这里可改为下拉选择并传对应 applyType
        applyType: "1",
        levelType: "1", // 1 中职组 2 高职组
        teamType: "teacher", // teacher / student
        zpname: "",
        principal: "",
        teams: "",
        suggestion: "",
        formFilePath: "",
      },

      // school list
      myQuery: {
        keyword: "",
        levelType: undefined,
        teamType: undefined,
      },
      myList: [],
      loadingMyList: false,

      // jyj list
      query: {
        schoolName: "",
        keyword: "",
        enrollStatus: undefined,
        levelType: undefined,
        teamType: undefined,
      },
      jyjList: [],
      jyjSelectedRowKeys: [],
      loadingJyjList: false,
      exportingForms: false,
      exportingExcel: false,
      pagination: {
        total: 0,
        current: 1,
        pageSize: 10,
        showTotal: (total) => `共 ${total} 条`,
      },
      audit: {
        visible: false,
        ids: [],
        status: 1,
        rejectReason: "",
        submitting: false,
      },
      resubmit: {
        visible: false,
        record: null,
        rejectReason: "",
        uploading: false,
        saving: false,
        submitting: false,
        formFileName: "",
        form: {
          applyType: "1",
          levelType: "",
          teamType: "",
          zpname: "",
          principal: "",
          teams: "",
          suggestion: "",
          formFilePath: "",
        },
      },

      schoolColumns: [
        { title: "作品名称", dataIndex: "zpname", key: "zpname", width: 140, ellipsis: true,align: "center"},
        { title: "作品负责人", dataIndex: "principal", key: "principal", width: 100,align: "center"},
        { title: "组别", dataIndex: "levelType", key: "levelType", width: 90,align: "center"},
        // { title: "团队类型", dataIndex: "teamType", key: "teamType", width: 100,align: "center"},
        {
          title: "团队成员",
          dataIndex: "teams",
          key: "teams",
          width: 240,
          scopedSlots: { customRender: "teams" },
          align: "center",
        },
        {
          title: "学校意见",
          dataIndex: "suggestion",
          key: "suggestion",
          width: 160,
          scopedSlots: { customRender: "suggestion" },
          align: "center",
        },
        {
          title: "报名表",
          dataIndex: "formFilePath",
          key: "formFilePath",
          width: 100,
          scopedSlots: { customRender: "formFilePath" },
          align: "center",
        },
        { title: "状态", dataIndex: "enrollStatus", key: "enrollStatus", width: 80, scopedSlots: { customRender: "enrollStatus" }    ,align: "center" },
        { title: "驳回原因", dataIndex: "rejectReason", key: "rejectReason", width: 140, ellipsis: true,align: "center"   },
        { title: "操作", key: "action", width: 120, scopedSlots: { customRender: "action" } ,align: "center"  },
      ],
      jyjColumns: [
        { title: "学校", dataIndex: "schoolName", key: "schoolName", width: 140, ellipsis: true    ,align: "center"},
        { title: "作品名称", dataIndex: "zpname", key: "zpname", width: 140, ellipsis: true    ,align: "center"},
        { title: "作品负责人", dataIndex: "principal", key: "principal", width: 100,align: "center"},
        { title: "组别", dataIndex: "levelType", key: "levelType", width: 90,align: "center"},
        // { title: "团队类型", dataIndex: "teamType", key: "teamType", width: 100,align: "center"},
        {
          title: "团队成员",
          dataIndex: "teams",
          key: "teams",
          width: 240,
          scopedSlots: { customRender: "teams" },
          align: "center",
        },
        {
          title: "学校意见",
          dataIndex: "suggestion",
          key: "suggestion",
          width: 160,
          scopedSlots: { customRender: "suggestion" },
          align: "center",
        },
        { title: "状态", dataIndex: "enrollStatus", key: "enrollStatus", width: 80, scopedSlots: { customRender: "enrollStatus" }    ,align: "center" },
        {
          title: "驳回原因",
          dataIndex: "rejectReason",
          key: "rejectReason",
          width: 160,
          scopedSlots: { customRender: "rejectReason" },
          align: "center",
        },
        {
          title: "报名表",
          dataIndex: "formFilePath",
          key: "formFilePath",
          width: 100,
          scopedSlots: { customRender: "formFilePath" },
          align: "center",
        },
        {
          title: "操作",
          key: "action",
          width: 140,
          fixed: "right",
          scopedSlots: { customRender: "action" },
          align: "center",
        },
      ],
    };
  },
  computed: {
    jyjRowSelection() {
      return {
        selectedRowKeys: this.jyjSelectedRowKeys,
        onChange: this.onJyjSelectionChange,
        getCheckboxProps: (record) => ({
          props: {
            disabled: this.normalizeEnrollStatus(record._rawEnrollStatus) === 1,
          },
        }),
      };
    },
    jyjSelectedPendingCount() {
      return this.getJyjSelectedRows().filter((r) =>
        this.isPendingStatus(r._rawEnrollStatus)
      ).length;
    },
    jyjSelectedApprovableCount() {
      return this.getJyjSelectedRows().filter((r) =>
        this.isApprovableStatus(r._rawEnrollStatus)
      ).length;
    },
    auditModalTitle() {
      const batch = this.audit.ids.length > 1;
      if (this.audit.status === 1) {
        return batch ? `批量审核通过（${this.audit.ids.length} 条）` : "审核通过";
      }
      return batch ? `批量审核驳回（${this.audit.ids.length} 条）` : "审核驳回";
    },
    exportSpinTip() {
      if (this.exportingForms) return "正在打包报名表...";
      if (this.exportingExcel) return "正在导出列表...";
      return "";
    },
    /** 列宽之和 + 勾选列，供横向滚动与右侧固定操作列 */
    jyjTableScrollX() {
      const colWidth = this.jyjColumns.reduce((sum, col) => sum + (col.width || 80), 0);
      return colWidth + 62;
    },
  },
  mounted() {
    if (this.$store.state.role === "school-role") {
      this.loadMyList();
    }
    if (this.$store.state.role === "education-role") {
      this.loadJyjList(1);
    }
  },
  methods: {
    getDefaultForm() {
      return {
        applyType: "1",
        levelType: "1",
        teamType: "teacher",
        zpname: "",
        principal: "",
        teams: "",
        suggestion: "",
        formFilePath: "",
      };
    },
    resetEnrollForm() {
      this.form = this.getDefaultForm();
      this.formFileName = "";
    },
    normalizeTeams(teams) {
      if (!teams) return "";
      return String(teams)
        .split(",")
        .map((s) => s.trim())
        .filter(Boolean)
        .sort()
        .join(",");
    },
    isDuplicateEnroll(data, excludeId) {
      const principal = (data.principal || "").trim();
      const zpname = (data.zpname || "").trim();
      const teams = this.normalizeTeams(data.teams);
      return this.myList.some((item) => {
        if (excludeId && item.id === excludeId) return false;
        if (item._rawEnrollStatus === 2) return false;
        const itemZpname = String(item._rawZpname || "").trim();
        return (
          String(item._rawLevelType) === String(data.levelType) &&
          // String(item._rawTeamType) === String(data.teamType) &&
          String(item._rawPrincipal || "").trim() === principal &&
          itemZpname === zpname &&
          this.normalizeTeams(item._rawTeams) === teams
        );
      });
    },
    beforeUpload(file) {
      const data = new FormData();
      data.append("file", file);
      this.uploading = true;
      return fileUp(data)
        .then((res) => {
          if (res.code === 200) {
            // /sys/common/local/upload 返回 Result.OK(ResInformation)，路径在 result.path
            const path = (res.result && res.result.path) || "";
            if (!path) {
              this.$message.error("上传成功但未返回文件路径");
              return false;
            }
            this.form.formFilePath = path;
            this.formFileName = file.name;
            this.$message.success("上传成功");
          } else {
            this.$message.error(res.message || "上传失败");
          }
          return false;
        })
        .finally(() => {
          this.uploading = false;
        });
    },

    submitEnroll() {
      if (!this.form.levelType) return this.$message.info("请选择中职组/高职组");
      // if (!this.form.teamType) return this.$message.info("请选择教师团队/学生团队");
      if (!this.form.zpname || !this.form.zpname.trim()) return this.$message.info("请填写作品名称");
      if (!this.form.principal || !this.form.principal.trim()) return this.$message.info("请填写负责人");
      if (!this.form.teams || !this.form.teams.trim()) return this.$message.info("请添加团队成员");
      if (!this.form.suggestion || !this.form.suggestion.trim()) return this.$message.info("请填写学校意见");
      if (!this.form.formFilePath) return this.$message.info("请先上传报名表");

      const normalizedPrincipal = this.form.principal.trim();
      const submitData = {
        ...this.form,
        zpname: this.form.zpname.trim(),
        teams: this.form.teams.trim(),
        suggestion: this.form.suggestion.trim(),
        principal: normalizedPrincipal,
      };
      if (this.isDuplicateEnroll(submitData)) {
        return this.$message.info(
          "同一负责人、作品名称、团队成员在同组别已提交报名表"
        );
      }

      this.submitting = true;
      lxEnrollSaveOrUpdate({
        ...submitData,
        principals: normalizedPrincipal,
      })
        .then((res) => {
          if (res.code === 200) {
            this.$message.success(res.message);
            this.resetEnrollForm();
            return this.loadMyList().then(() => {
              this.$nextTick(() => this.scrollToMyRecordList());
            });
          } else {
            this.$message.error(res.message);
          }
        })
        .finally(() => {
          this.submitting = false;
        });
    },
    scrollToMyRecordList() {
      const el = this.$refs.myRecordSection;
      if (!el) return;
      const node = el.$el || el;
      if (node && typeof node.scrollIntoView === "function") {
        node.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    },

    resetMyQuery() {
      this.myQuery.keyword = "";
      this.myQuery.levelType = undefined;
      this.myQuery.teamType = undefined;
      this.loadMyList();
    },
    setMyLevelFilter(value) {
      this.myQuery.levelType =
        value === undefined || value === null || value === ""
          ? undefined
          : String(value);
      this.loadMyList();
    },
    setMyTeamFilter(value) {
      this.myQuery.teamType =
        value === undefined || value === null || value === ""
          ? undefined
          : value;
      this.loadMyList();
    },
    resetJyjQuery() {
      this.query.schoolName = "";
      this.query.keyword = "";
      this.query.enrollStatus = undefined;
      this.query.levelType = undefined;
      this.query.teamType = undefined;
      this.loadJyjList(1);
    },
    setJyjStatusFilter(value) {
      this.query.enrollStatus =
        value === undefined || value === null || value === ""
          ? undefined
          : value;
      this.loadJyjList(1);
    },
    setJyjLevelFilter(value) {
      this.query.levelType =
        value === undefined || value === null || value === ""
          ? undefined
          : String(value);
      this.loadJyjList(1);
    },
    setJyjTeamFilter(value) {
      this.query.teamType =
        value === undefined || value === null || value === ""
          ? undefined
          : value;
      this.loadJyjList(1);
    },
    loadMyList() {
      this.loadingMyList = true;
      return lxEnrollMyList({
        levelType: this.myQuery.levelType,
        // teamType: this.myQuery.teamType,
        keyword: (this.myQuery.keyword || "").trim() || undefined,
      })
        .then((res) => {
          if (res.code === 200) {
            this.myList = (res.result || []).map((x) => this.formatRow(x));
          } else {
            this.$message.error(res.message);
          }
        })
        .finally(() => {
          this.loadingMyList = false;
        });
    },

    getJyjExportParams() {
      return {
        applyType: this.form.applyType,
        schoolName: (this.query.schoolName || "").trim() || undefined,
        keyword: (this.query.keyword || "").trim() || undefined,
        levelType: this.query.levelType,
        // teamType: this.query.teamType,
        enrollStatus: this.query.enrollStatus,
      };
    },
    downloadExcelBlob(res, fileName) {
      if (!res) {
        this.$message.warning("文件下载失败");
        return;
      }
      const blob = res instanceof Blob ? res : new Blob([res], { type: "application/vnd.ms-excel" });
      if (typeof window.navigator.msSaveBlob !== "undefined") {
        window.navigator.msSaveBlob(blob, fileName + ".xlsx");
      } else {
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.style.display = "none";
        link.href = url;
        link.setAttribute("download", fileName + ".xlsx");
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      }
      this.$message.success("导出成功");
    },
    exportJyjExcel() {
      this.exportingExcel = true;
      lxEnrollExportExcel(this.getJyjExportParams())
        .then((res) => {
          this.downloadExcelBlob(res, "报名审核");
        })
        .catch(() => {
          this.$message.error("导出失败，请稍后重试");
        })
        .finally(() => {
          this.exportingExcel = false;
        });
    },
    exportApprovedForms() {
      this.exportingForms = true;
      const params = this.getJyjExportParams();
      delete params.enrollStatus;
      lxEnrollExportApprovedZip(params)
        .then(async (res) => {
          const blob = res instanceof Blob ? res : new Blob([res]);
          if (blob.type && blob.type.indexOf("json") >= 0) {
            const text = await blob.text();
            try {
              const json = JSON.parse(text);
              this.$message.warning(json.message || "导出失败");
            } catch (e) {
              this.$message.warning("导出失败");
            }
            return;
          }
          if (!blob.size) {
            this.$message.warning("暂无已通过的报名表");
            return;
          }
          const url = window.URL.createObjectURL(
            new Blob([blob], { type: "application/zip" })
          );
          const link = document.createElement("a");
          link.style.display = "none";
          link.href = url;
          link.setAttribute("download", "通过报名表.zip");
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);
          this.$message.success("导出成功");
        })
        .catch(async (err) => {
          const data = err.response && err.response.data;
          if (data instanceof Blob) {
            try {
              const json = JSON.parse(await data.text());
              this.$message.warning(json.message || "导出失败");
              return;
            } catch (e) {
              /* ignore */
            }
          }
          this.$message.error("导出失败，请稍后重试");
        })
        .finally(() => {
          this.exportingForms = false;
        });
    },

    loadJyjList(pageNo) {
      this.loadingJyjList = true;
      this.pagination.current = pageNo;
      lxEnrollJyjList({
        pageNo,
        pageSize: this.pagination.pageSize,
        schoolName: (this.query.schoolName || "").trim() || undefined,
        keyword: (this.query.keyword || "").trim() || undefined,
        enrollStatus: this.query.enrollStatus,
        levelType: this.query.levelType,
        // teamType: this.query.teamType,
        applyType: this.form.applyType,
      })
        .then((res) => {
          if (res.code === 200) {
            const p = res.result || {};
            this.pagination.total = p.total || 0;
            this.jyjList = (p.records || []).map((x) => this.formatRow(x));
          } else {
            this.$message.error(res.message);
          }
        })
        .finally(() => {
          this.loadingJyjList = false;
          this.pruneJyjSelection();
        });
    },

    onJyjSelectionChange(keys) {
      this.jyjSelectedRowKeys = keys;
      this.pruneJyjSelection();
    },
    pruneJyjSelection() {
      const selectableIds = new Set(
        this.jyjList
          .filter((r) => this.normalizeEnrollStatus(r._rawEnrollStatus) !== 1)
          .map((r) => r.id)
      );
      this.jyjSelectedRowKeys = this.jyjSelectedRowKeys.filter((id) => selectableIds.has(id));
    },
    getJyjSelectedRows() {
      const keySet = new Set(this.jyjSelectedRowKeys);
      return this.jyjList.filter((r) => keySet.has(r.id));
    },
    normalizeEnrollStatus(status) {
      if (status === 0 || status === "0") return 0;
      if (status === 1 || status === "1") return 1;
      if (status === 2 || status === "2") return 2;
      const n = Number(status);
      return Number.isNaN(n) ? status : n;
    },
    isPendingStatus(status) {
      return this.normalizeEnrollStatus(status) === 0;
    },
    isApprovableStatus(status) {
      const s = this.normalizeEnrollStatus(status);
      return s === 0 || s === 2;
    },
    isRejectableStatus(status) {
      return this.normalizeEnrollStatus(status) !== 2;
    },

    onTableChange(pagination) {
      this.pagination.current = pagination.current;
      this.pagination.pageSize = pagination.pageSize;
      this.loadJyjList(pagination.current);
    },

    openAudit(record, status) {
      if (!record || !record.id) return;
      this.audit.visible = true;
      this.audit.ids = [record.id];
      this.audit.status = status;
      this.audit.rejectReason = "";
    },
    openBatchAudit(status) {
      const selected = this.getJyjSelectedRows();
      if (!selected.length) {
        return this.$message.info("请先勾选记录");
      }
      let ids;
      if (status === 1) {
        ids = selected
          .filter((r) => this.isApprovableStatus(r._rawEnrollStatus))
          .map((r) => r.id);
        if (!ids.length) {
          return this.$message.info("所选记录均已通过，无法批量通过");
        }
      } else {
        ids = selected
          .filter((r) => this.isPendingStatus(r._rawEnrollStatus))
          .map((r) => r.id);
        if (!ids.length) {
          return this.$message.info("批量驳回仅支持待审记录");
        }
      }
      this.audit.visible = true;
      this.audit.ids = ids;
      this.audit.status = status;
      this.audit.rejectReason = "";
    },

    doAudit() {
      if (!this.audit.ids.length) {
        return this.$message.warning("未选择报名记录");
      }
      if (this.audit.status === 2 && !this.audit.rejectReason.trim()) {
        return this.$message.info("请填写驳回原因");
      }
      this.audit.submitting = true;
      lxEnrollAudit({
        ids: this.audit.ids.join(","),
        enrollStatus: this.audit.status,
        rejectReason: this.audit.rejectReason,
      })
        .then((res) => {
          if (res.code === 200) {
            this.$message.success(res.message);
            this.audit.visible = false;
            this.jyjSelectedRowKeys = [];
            this.loadJyjList(this.pagination.current);
          } else {
            this.$message.error(res.message);
          }
        })
        .finally(() => {
          this.audit.submitting = false;
        });
    },
    handleDelete(record) {
      if (!record || !record.id) {
        return this.$message.warning("未找到要删除的报名记录");
      }
      lxEnrollDelete({ id: record.id }).then((res) => {
        if (res.code === 200) {
          this.$message.success(res.message || "删除成功");
          if (this.$store.state.role === "education-role") {
            this.jyjSelectedRowKeys = this.jyjSelectedRowKeys.filter(
              (id) => id !== record.id
            );
            const page = this.pagination.current;
            const reloadPage =
              this.jyjList.length === 1 && page > 1 ? page - 1 : page;
            this.loadJyjList(reloadPage);
          } else {
            this.loadMyList();
          }
        } else {
          this.$message.error(res.message || "删除失败");
        }
      });
    },
    openResubmit(record) {
      this.resubmit.record = record;
      this.resubmit.rejectReason = record && record.rejectReason ? record.rejectReason : "";
      this.resubmit.form = {
        applyType: this.form.applyType,
        levelType: String(record._rawLevelType || ""),
        teamType: String(record._rawTeamType || ""),
        zpname: record._rawZpname || (record.zpname === "-" ? "" : record.zpname) || "",
        principal: record._rawPrincipal || "",
        teams: record._rawTeams || "",
        suggestion: record._rawSuggestion || "",
        formFilePath: record._rawFormPath || "",
      };
      this.resubmit.formFileName = this.getDisplayFileName(record._rawFormPath);
      this.resubmit.visible = true;
    },
    beforeUploadResubmit(file) {
      const data = new FormData();
      data.append("file", file);
      this.resubmit.uploading = true;
      return fileUp(data)
        .then((res) => {
          if (res.code === 200) {
            const path = (res.result && res.result.path) || "";
            if (!path) {
              this.$message.error("上传成功但未返回文件路径");
              return false;
            }
            this.resubmit.form.formFilePath = path;
            this.resubmit.formFileName = file.name;
            this.$message.success("上传成功");
          } else {
            this.$message.error(res.message || "上传失败");
          }
          return false;
        })
        .finally(() => {
          this.resubmit.uploading = false;
        });
    },
    doResubmitSave() {
      if (!this.resubmit.record || !this.resubmit.record.id) {
        return this.$message.warning("未找到要编辑的驳回记录");
      }
      if (!this.resubmit.form.levelType) return this.$message.info("请选择中职组/高职组");
      // if (!this.resubmit.form.teamType) return this.$message.info("请选择教师团队/学生团队");
      if (!this.resubmit.form.zpname || !this.resubmit.form.zpname.trim()) return this.$message.info("请填写作品名称");
      if (!this.resubmit.form.principal || !this.resubmit.form.principal.trim()) return this.$message.info("请填写负责人");
      if (!this.resubmit.form.teams || !this.resubmit.form.teams.trim()) return this.$message.info("请添加团队成员");
      if (!this.resubmit.form.suggestion || !this.resubmit.form.suggestion.trim()) return this.$message.info("请填写学校意见");
      if (!this.resubmit.form.formFilePath) return this.$message.info("请先上传报名表");

      const normalizedPrincipal = this.resubmit.form.principal.trim();
      const saveData = {
        ...this.resubmit.form,
        zpname: this.resubmit.form.zpname.trim(),
        teams: this.resubmit.form.teams.trim(),
        suggestion: this.resubmit.form.suggestion.trim(),
        principal: normalizedPrincipal,
      };
      if (this.isDuplicateEnroll(saveData, this.resubmit.record.id)) {
        return this.$message.info(
          "同一负责人、作品名称、团队成员在同组别已提交报名表"
        );
      }
      this.resubmit.saving = true;
      lxEnrollUpdateRejected({
        id: this.resubmit.record.id,
        ...saveData,
      })
        .then((res) => {
          if (res.code === 200) {
            this.$message.success(res.message || "保存成功");
            this.resubmit.visible = false;
            this.loadMyList();
          } else {
            this.$message.error(res.message || "保存失败");
          }
        })
        .finally(() => {
          this.resubmit.saving = false;
        });
    },
    doResubmitSubmit() {
      if (!this.resubmit.record || !this.resubmit.record.id) {
        return this.$message.warning("未找到要重新提交的驳回记录");
      }
      if (!this.resubmit.form.levelType) return this.$message.info("请选择中职组/高职组");
      // if (!this.resubmit.form.teamType) return this.$message.info("请选择教师团队/学生团队");
      if (!this.resubmit.form.zpname || !this.resubmit.form.zpname.trim()) return this.$message.info("请填写作品名称");
      if (!this.resubmit.form.principal || !this.resubmit.form.principal.trim()) return this.$message.info("请填写负责人");
      if (!this.resubmit.form.teams || !this.resubmit.form.teams.trim()) return this.$message.info("请添加团队成员");
      if (!this.resubmit.form.suggestion || !this.resubmit.form.suggestion.trim()) return this.$message.info("请填写学校意见");
      if (!this.resubmit.form.formFilePath) return this.$message.info("请先上传报名表");

      const normalizedPrincipal = this.resubmit.form.principal.trim();
      const submitData = {
        ...this.resubmit.form,
        zpname: this.resubmit.form.zpname.trim(),
        teams: this.resubmit.form.teams.trim(),
        suggestion: this.resubmit.form.suggestion.trim(),
        principal: normalizedPrincipal,
      };
      if (this.isDuplicateEnroll(submitData, this.resubmit.record.id)) {
        return this.$message.info(
          "同一负责人、作品名称、团队成员在同组别已提交报名表"
        );
      }
      this.resubmit.submitting = true;
      lxEnrollSaveOrUpdate({
        id: this.resubmit.record.id,
        ...submitData,
        principals: normalizedPrincipal,
      })
        .then((res) => {
          if (res.code === 200) {
            this.$message.success(res.message || "提交成功");
            this.resubmit.visible = false;
            return this.loadMyList().then(() => {
              this.$nextTick(() => this.scrollToMyRecordList());
            });
          } else {
            this.$message.error(res.message || "提交失败");
          }
        })
        .finally(() => {
          this.resubmit.submitting = false;
        });
    },
    getDisplayFileName(path) {
      if (!path) return "";
      const fileName = path.substring(path.lastIndexOf("/") + 1);
      const underlineIndex = fileName.lastIndexOf("_");
      if (underlineIndex > 0) {
        return fileName.substring(0, underlineIndex) + fileName.substring(fileName.lastIndexOf("."));
      }
      return fileName;
    },

    formatRow(row) {
      const levelTypeText = row.levelType === "1" ? "中职组" : row.levelType === "2" ? "高职组" : row.levelType;
      // const teamTypeText =
      //   row.teamType === "teacher" ? "教师团队" : row.teamType === "student" ? "学生团队" : row.teamType;
      const rawStatus = this.normalizeEnrollStatus(row.enrollStatus);
      const statusText =
        rawStatus === 0 ? "待审" : rawStatus === 1 ? "通过" : rawStatus === 2 ? "驳回" : row.enrollStatus;
      const principalText = row.principal || row.principals || "-";
      return {
        ...row,
        principal: principalText,
        zpname: row.zpname || "-",
        teams: row.teams || "",
        suggestion: row.suggestion || "-",
        rejectReason: row.rejectReason && String(row.rejectReason).trim() ? row.rejectReason : "-",
        _rawZpname: row.zpname || "",
        _rawTeams: row.teams || "",
        _rawSuggestion: row.suggestion || "",
        _rawFormPath: row.formFilePath,
        _rawLevelType: row.levelType,
        _rawTeamType: row.teamType,
        _rawPrincipal: row.principal || row.principals || "",
        _rawEnrollStatus: this.normalizeEnrollStatus(row.enrollStatus),
        levelType: levelTypeText,
        // teamType: teamTypeText,
        enrollStatus: statusText,
      };
    },
    openPreview(path) {
      if (!path) {
        this.$message.warning("暂无报名表路径");
        return;
      }
      // 复用项目原有预览组件（按文件类型预览/下载）
      this.$refs.previewImg.init(path);
    },
    getStatusClass(statusText) {
      if (statusText === "通过") return "status-pass";
      if (statusText === "驳回") return "status-reject";
      return "status-await";
    },
  },
};
</script>

<style scoped lang="scss">
.enroll-page {
  padding: 20px 25px;
}
.section-card {
  background: #fff;
  border: 1px solid #eaf0ff;
  border-radius: 10px;
  padding: 16px 18px 8px;
  box-shadow: 0 2px 10px rgba(0, 90, 245, 0.05);
}
.section-title {
  position: relative;
  display: inline-block;
  padding: 4px 12px;
  margin-bottom: 14px;
  font-size: 16px;
  font-weight: 600;
  color: #9A0B00;
  background: #eef4ff;
  border-radius: 999px;
}
.enroll-form-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 14px 48px;
  max-width: 920px;
}
.enroll-form-grid .form-row {
  margin-bottom: 0;
}
.enroll-form-grid .form-row--full {
  grid-column: 1 / -1;
}
.form-row {
  display: flex;
  align-items: center;
  margin-bottom: 16px;
}
.form-row-content {
  flex: 1;
  min-width: 0;
}
.form-row-content .ant-input,
.form-row-content .ant-input-affix-wrapper {
  width: 100%;
  max-width: 320px;
}
.form-row-content textarea.ant-input {
  max-width: 100%;
}
.form-row-content--inline {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px 12px;
}
.form-row-top {
  align-items: flex-start;
  .label {
    padding-top: 6px;
  }
}
.label {
  width: 100px;
  flex-shrink: 0;
  color: #333;
}
.required {
  color: #f6350f;
  margin-right: 4px;
}
.file-tip {
  margin-left: 0;
  color: #666;
  font-size: 13px;
}
@media (max-width: 768px) {
  .enroll-form-grid {
    grid-template-columns: 1fr;
    gap: 14px;
  }
}
.actions {
  margin: 12px auto 12px;
  display: flex;
  justify-content: center;
}
.list-filter-footer--jyj {
  gap: 8px 10px;
}
.list-filter-footer-split {
  width: 1px;
  height: 18px;
  margin: 0 4px;
  background: #d9d9d9;
  flex-shrink: 0;
}
.jyj-batch-tip {
  font-size: 13px;
  color: #666;
  white-space: nowrap;
}
.jyj-batch-tip b {
  color: #9A0B00;
  font-weight: 600;
}
.jyj-export-group {
  display: inline-flex;
  align-items: stretch;
  overflow: hidden;
  border: 1px solid #d6e4ff;
  border-radius: 6px;
  background: #fff;
}
.list-filter-panel {
  margin-bottom: 14px;
  padding: 14px 16px;
  background: #f8faff;
  border: 1px solid #d6e4ff;
  border-radius: 10px;
}
.list-filter-row {
  margin-bottom: 12px;
}
.list-filter-row:last-child {
  margin-bottom: 0;
}
.list-filter-search-row {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
}
.list-filter-search {
  flex: 1;
  min-width: 220px;
  max-width: 360px;
}
.list-filter-options {
  display: flex;
  flex-wrap: wrap;
  gap: 16px 32px;
}
.filter-dimension-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 14px;
  width: 100%;
}
.filter-dimension-grid.filter-dimension-grid--cols-3 {
  grid-template-columns: repeat(3, minmax(0, 1fr));
}
.filter-dimension-grid--my {
  margin-bottom: 12px;
  padding-bottom: 14px;
  border-bottom: 1px dashed #e0e0e0;
}
.filter-dimension-grid--my + .list-filter-search-row {
  margin-top: 4px;
}
.filter-chip-list--my {
  gap: 24px;
}
.filter-chip--my {
  min-width: auto;
  padding: 5px 16px;
  font-size: 13px;
  border-radius: 4px;
}
.filter-dimension-grid--cols-3 .filter-chip-list--lg {
  display: flex;
  flex-wrap: nowrap;
  gap: 8px;
  width: 100%;
}
.filter-dimension-grid--cols-3 .filter-chip--lg {
  flex: 1;
  min-width: 0;
  padding: 8px 6px;
  font-size: 13px;
}
.filter-dimension-block {
  padding: 12px 16px;
  background: #fff;
  border: 1px solid #e6eefc;
  border-radius: 8px;
}
.filter-dimension-block--primary {
  border-color: #b8d4ff;
  background: linear-gradient(180deg, #fff 0%, #f3f8ff 100%);
  box-shadow: 0 1px 4px rgba(0, 90, 245, 0.08);
}
.filter-dimension-title {
  margin-bottom: 10px;
  padding-bottom: 8px;
  font-size: 15px;
  font-weight: 600;
  color: #1a1a1a;
  border-bottom: 1px solid #eef3fc;
}
.filter-dimension-block--primary .filter-dimension-title {
  color: #9A0B00;
  border-bottom-color: #d6e4ff;
}
.filter-chip-list--lg {
  gap: 10px;
}
.filter-chip--lg {
  min-width: 96px;
  padding: 8px 22px;
  font-size: 14px;
  border-radius: 8px;
}
.filter-option-group {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
}
.filter-option-label {
  flex-shrink: 0;
  font-size: 14px;
  font-weight: 600;
  color: #333;
  min-width: 64px;
}
.filter-chip-list {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}
.filter-chip {
  display: inline-block;
  min-width: 72px;
  padding: 6px 16px;
  font-size: 14px;
  text-align: center;
  color: #555;
  background: #fff;
  border: 1px solid #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  user-select: none;
  transition: all 0.2s;
}
.filter-chip:hover {
  color: #9A0B00;
  border-color: #91b8ff;
}
.filter-chip.active {
  color: #fff;
  background: #9A0B00;
  border-color: #9A0B00;
  font-weight: 600;
  box-shadow: 0 2px 6px rgba(0, 90, 245, 0.25);
}
.filter-chip.status-pass-chip.active {
  background: #52c41a;
  border-color: #52c41a;
}
.filter-chip.status-reject-chip.active {
  background: #f5222d;
  border-color: #f5222d;
}
.list-filter-footer {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
  padding-top: 14px;
  border-top: 1px dashed #e0e0e0;
}
.list-filter-count {
  margin-left: auto;
  font-size: 13px;
  color: #666;
}
.list-filter-count b {
  color: #9A0B00;
  font-weight: 600;
}
@media (max-width: 768px) {
  .filter-dimension-grid {
    grid-template-columns: 1fr;
  }
  .filter-dimension-grid--cols-3 {
    grid-template-columns: 1fr;
  }
}
.empty-tip {
  padding: 20px;
  color: #666;
}
.record-section {
  margin-top: 22px;
  background: #fff;
  border: 1px solid #eaf0ff;
  border-radius: 10px;
  padding: 16px 18px;
  box-shadow: 0 2px 10px rgba(0, 90, 245, 0.05);
}
.cell-ellipsis {
  display: inline-block;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  vertical-align: middle;
}
/deep/ .enroll-table .ant-table-tbody > tr > td,
/deep/ .enroll-table .ant-table-thead > tr > th {
  padding: 10px 8px !important;
  height: auto;
  vertical-align: middle;
}
.action-group {
  display: inline-flex;
  align-items: center;
  white-space: nowrap;
}
.status-await {
  color: #fa8c16;
}
.status-pass {
  color: #52c41a;
}
.status-reject {
  color: #f5222d;
}
.action-pass {
  color: #52c41a;
  margin-right: 12px;
}
.action-pass:hover {
  color: #73d13d;
}
.action-reject {
  color: #f5222d;
  margin-right: 12px;
}
.action-reject:hover {
  color: #ff4d4f;
}
.action-delete {
  color: #ff4d4f;
  margin-right: 12px;
}
.action-delete:hover {
  color: #ff7875;
}
.action-resubmit {
  color: #1677ff;
  margin-right: 12px;
}
.action-resubmit:hover {
  color: #4096ff;
}
.reject-reason {
  margin-top: 12px;
  padding: 10px 12px;
  border-radius: 8px;
  background: #fff2f0;
  border: 1px solid #ffccc7;
}
.reject-title {
  font-weight: 600;
  color: #cf1322;
  margin-bottom: 6px;
}
.reject-text {
  color: #666;
  white-space: pre-line;
}
</style>

<style lang="scss">
/* 批量审核：与筛选区、表格操作链接同系的低饱和描边样式 */
.enroll-page .list-filter-footer--jyj .jyj-batch-btn.ant-btn {
  opacity: 1;
}

.enroll-page .list-filter-footer--jyj .jyj-batch-btn--pass.ant-btn[disabled],
.enroll-page .list-filter-footer--jyj .jyj-batch-btn--reject.ant-btn[disabled] {
  color: rgba(0, 0, 0, 0.25);
  background: #fff;
  border-color: #d9d9d9;
}

.enroll-page .list-filter-footer--jyj .jyj-batch-btn--pass.is-ready.ant-btn {
  color: #52c41a;
  background: #fff;
  border-color: #b7eb8f;
}
.enroll-page .list-filter-footer--jyj .jyj-batch-btn--pass.is-ready.ant-btn:hover,
.enroll-page .list-filter-footer--jyj .jyj-batch-btn--pass.is-ready.ant-btn:focus {
  color: #389e0d;
  background: #f6ffed;
  border-color: #95de64;
}

.enroll-page .list-filter-footer--jyj .jyj-batch-btn--reject.is-ready.ant-btn {
  color: #f5222d;
  background: #fff;
  border-color: #ffccc7;
}
.enroll-page .list-filter-footer--jyj .jyj-batch-btn--reject.is-ready.ant-btn:hover,
.enroll-page .list-filter-footer--jyj .jyj-batch-btn--reject.is-ready.ant-btn:focus {
  color: #cf1322;
  background: #fff1f0;
  border-color: #ffa39e;
}

.enroll-page .jyj-export-group .jyj-export-btn.ant-btn {
  height: 28px;
  padding: 0 12px;
  font-size: 13px;
  line-height: 26px;
  border: none;
  border-radius: 0;
  box-shadow: none;
  transition: color 0.2s, background 0.2s;
}

.enroll-page .jyj-export-group .jyj-export-btn--zip.ant-btn {
  border-left: 1px solid #e8eef8;
}

.enroll-page .jyj-export-group .jyj-export-btn--excel.ant-btn {
  color: #389e0d;
  background: #fff;
}
.enroll-page .jyj-export-group .jyj-export-btn--excel.ant-btn:hover,
.enroll-page .jyj-export-group .jyj-export-btn--excel.ant-btn:focus {
  color: #237804;
  background: #f6ffed;
}

.enroll-page .jyj-export-group .jyj-export-btn--zip.ant-btn {
  color: #9A0B00;
  background: #fff;
}
.enroll-page .jyj-export-group .jyj-export-btn--zip.ant-btn:hover,
.enroll-page .jyj-export-group .jyj-export-btn--zip.ant-btn:focus {
  color: #003eb3;
  background: #f0f6ff;
}

.enroll-page .jyj-export-group .jyj-export-btn.ant-btn.ant-btn-loading {
  opacity: 0.85;
}
</style>

